
import {gql} from "apollo-angular";

const LOGIN_MUTATION_MKT = gql`
  mutation LoginMkt($email: String!, $pass: String!) {
    loginMkt(loginInput: { email: $email, pass: $pass }) {
      access_token
      user {
        _id
        email
        status
        username
        avatar
      }
      roles
    }
  }
`;





const sucursalesActivas = gql  `
  query{
    getSucursalesActivas{
      cod_ciudad,
      sucursal_nombre_comercial,
      sucursal_direccion,
      codSucursal
    }
  }
`;
const getEspecialidadesNavBar = gql  `
  query GetAllEspecialidades {
  getAllEspecialidades(limit: 3, filter: { esp_es_agendable: true }) {
    cod_especialidad
    esp_es_agendable
    esp_nombre
    esp_toma_signos_aten_directa
  }
}
`;
const getAllEspecialidadesNavBar = gql  `
  query GetAllEspecialidades {
  getAllEspecialidades( filter: { esp_es_agendable: true }) {
    cod_especialidad
    esp_nombre
  }
}
`;
const getServicesNavBar = gql  `
  query GetAllServiciosProcedimientos {
    getAllServiciosProcedimientos(limit: 3, filter: { agenda_consulta: true }) {
        serv_nombre
    }
}
`;
const getAllServicesNavBar = gql  `
  query GetAllServiciosProcedimientos {
    getAllServiciosProcedimientos( filter: { agenda_consulta: true }) {
        serv_nombre
    }
}
`;
const getAllPromociones = gql  `
  query{
  getAllPromociones{
    aplica_cambio_cobertura,
    aplica_porcentaje,
    aplica_todo,
    cli_empresa,
    codDescuentos,
    cod_origen_transaccion,
    estado,
    nombre_descuento,
    observacion,
    promocion_global,
    promocion_interna,
    tiene_vigencia,
    tipo_desc,
    valor_desc,
    valor_desc_mult,
    fecha_vigencia,
    fecha_inicio
  }
}
`;

const getAllPromocionesWeb = gql  `
  query GetAllPromocionesWeb {
    getAllPromocionesWeb {
        nombre_descuento,
        tipo_desc,
        valor_desc,
      codDescuentos
    }
}`;

const SERVICIOS_POR_DESCUENTO = gql`
  query ServiciosPorDescuento($codDescuentos: Int!) {
    serviciosPorDescuento(codDescuentos: $codDescuentos) {
      serv_nombre
    }
  }
`;


const getAllEspecialidadesMongo = gql  `
query{
  getAllEspecialidadesMongo{
    _id,
    cod_servicio_procedimiento,
    intro_descripcion,
    serv_nombre
  }
}
`;

const getAllPromocionesMongoFront = gql  `
  query {
    getAllDataWebPublic  {
      promociones {
        codPromocionSam,
        descripcion,
        imagenPromocion,
        nombre,
        precio,
        servicios,
        tipoPromocion,
        statusPromocion,
        createdAt,
        fechaExpiracion
      }
      categoria
    }
  }

`;

const getAllCategorias = gql  `
  query GetAllDataWebPublic {
    getAllDataWebPublic {
      categoria,
      descripcion,
      especialidad,
      imagen
      icono
      promociones{
        _id
      }
    }
  }
`;

const getOneCategoria = gql  `
  query GetAllDataWebPublic($nameEspecialidad: String!) {
    getAllDataWebPublic(nameEspecialidad: $nameEspecialidad) {
      categoria
      descripcion
      especialidad
      imagen
      icono,
      procedimientosList,
      centrosMedicos{
        ciudad
        direccionSucursal,
        linkMaps,
        nameSucursal
      },
      promociones{
        _id
        codPromocionSam
        createdAt
        descripcion
        disclaimer
        especialidad
        fechaExpiracion
        imagenPromocion
        isFeatured
        nombre
        precio
        servicios
        statusPromocion
        tipoPromocion
      }

    }
  }

`;



const GET_PROMOTIONS_FEATURED = gql`
  query GetPromotionsFeatured ($limit: Int, $especialidad: String) {
    getPromotionsFeatured (limit: $limit, especialidad: $especialidad) {
      _id
      codPromocionSam
      createdAt
      descripcion
      disclaimer
      fechaExpiracion
      imagenPromocion
      isFeatured
      nombre
      precio
      servicios
      statusPromocion
      tipoPromocion
      especialidad
    }
  }
`;


  const getAllPromocionesMongo = gql  `
query{
  getAllPromocionesMongo{
    _id,
    codPromocionSam,
    descripcion,
    disclaimer,
    namePromocion,
    status,
    tipoPromocion,
    valorPromocion,
    vigencia,
    imagenUrl
  }
}
`;


const getEspecialidadesNavBarMongo = gql`
query{
  getAllEspecialidadesMongo(limit: 3){
    _id,
    cod_servicio_procedimiento,
    serv_nombre

  }
}
`;

const getOneEspecialidadMongo = gql`
  query getOneEspecialidadesMongo($cod_servicio_procedimiento: Int!) {
    getOneEspecialidadesMongo(cod_servicio_procedimiento: $cod_servicio_procedimiento) {
      cod_servicio_procedimiento
      intro_descripcion
      serv_nombre,
      descripcion
    }
  }
`;


const getOnePromotion = gql`
  query GetOnePromotion ($cod_descuentos: Int!){
    getOnePromotion(cod_descuentos: $cod_descuentos) {
        aplica_cambio_cobertura
        aplica_porcentaje
        aplica_todo
        cli_empresa
        codDescuentos
        cod_origen_transaccion
        estado
        fecha_vigencia
        nombre_descuento
        observacion
        promocion_global
        promocion_interna
        tiene_vigencia
        tipo_desc
        valor_desc
        valor_desc_mult
        fecha_inicio
    }
}`;

const findPersonaByCedula = gql`
  query FindPersonaByCedula ($identificacion: String!){
    findPersonaByCedula(identificacion: $identificacion) {
        cli_nombres_completos
        codPersona
        pers_email
        cli_no_identificacion
    }
}`;

const createPersona = gql`
  mutation CreatePersona($input: CreatePersonaInputDto!) {
    createPersona(createPersonaInput: $input) {
      cli_direccion
      cli_no_identificacion
      cli_nombres_completos
      cli_telefono_principal
      cod_origen_persona
      codPersona
      cod_tipo_identificacion
      pers_email
      pers_genero_sexo
      pers_segundo_apellido
      pers_segundo_nombre
    }
  }
`;

const createOrdenesServicio = gql`
  mutation createOrdenesServicio($input: CreateOrdenesServicioInputDto!) {
    createOrdenesServicio(createOrdenesServicioInput: $input) {
      codOrdenServicio
      codUsuario
      ordEnvSio
      ordEstado
      ordEstadoCredito
      ordEstadoFacturacion
      ordFechaCreacion
      ordOrigen
      ordPaquete
      ordPorcentajeCompleto
    }
  }
`;


const createOrden = gql`
  mutation createOrden($input: CreateOrdenInputDto!) {
    createOrden(createOrdenInput: $input)
  }
`;

const getAdmisionByCodePersona = gql`
  query GetAdmisionByCodePersona($codPersonaPaciente: Int!, $codEmpresaCliente: Int!) {
    findAdmisionByCodePersona(codPersonaPaciente: $codPersonaPaciente, codEmpresaCliente: $codEmpresaCliente) {
      codPersonaPaciente
      codPersonaTitular
      codPersonaAdmision
      codEmpresaCliente
    }
  }
`;

const createPromocionesMongo = gql`
  mutation CreatePromocionesMongo($input: CreatePromotionsInputDto!) {
    createPromocionesMongo(createPromotionsInputDto: $input) {
      _id
      codPromocionSam
      descripcion
      disclaimer
      namePromocion
      status
      tipoPromocion
      valorPromocion
      vigencia
      imagenUrl
    }
  }
`;

const get_promocionMongoById = gql`
  query GetPromocionMongoById($id: String!) {
    getPromocionMongoById(id: $id) {
      _id
      codPromocionSam
      descripcion
      disclaimer
      imagenUrl
      namePromocion
      status
      tipoPromocion
      valorPromocion
      vigencia
    }
  }
`;


const udpatePromocionMongoById = gql`
  mutation UpdatePromocioMongoById($id: String!, $updatePromotionsInputDto: CreatePromotionsInputDto!) {
    updatePromocioMongoById(id: $id,
      updatePromotionsInputDto: $updatePromotionsInputDto) {
      _id
      codPromocionSam
      descripcion
      disclaimer
      imagenUrl
      namePromocion
      status
      tipoPromocion
      valorPromocion
      vigencia
    }
  }
`;

const findPromocionMongoByCodSam = gql`
query GetPromocionMongoByCodSam($codSam: Int!) {
  getPromocionMongoByCodSam(codSam: $codSam) {
    descripcion
    disclaimer
    imagenUrl
  }
}
`;



 const GET_ALL_PROMOCIONES_WEB = gql`
  query GetAllDataWebPrivate {
    getAllDataWebPrivate {
      categoria
      promociones {
        codPromocionSam
        descripcion
        disclaimer
        fechaExpiracion
        imagenPromocion
        nombre
        precio
        servicios
        statusPromocion
        tipoPromocion
        isFeatured

      }
    }
  }
`;

const GET_ALL_DATA_WEB_PUBLIC = gql`
  query GetAllDataWeb {
    getAllDataWeb {
      _id
      categoria
      descripcion
      especialidad
      imagen
      showNavBar
    }
  }
`;


const CREAR_ESPECIALIDAD = gql`
  mutation CreateDataWeb($input: CreateDataWebInputDto!) {
    createDataWeb(input: $input) {
      _id
      categoria
      descripcion
      especialidad
      imagen
      showNavBar
    }
  }
`;

const GET_DATA_BY_ID = gql`
  query GetDataById($id: ID!) {
    getDataById(id: $id) {
      _id
      categoria
      descripcion
      especialidad
      imagen
      icono
      showNavBar,
      procedimientosList,
      centrosMedicos{
        ciudad
        direccionSucursal,
        linkMaps,
        nameSucursal
      }
    }
  }
`;

const DELETEDATABYID = gql`
  mutation DeleteDataWeb($id: ID!) {
    deleteDataWeb(id: $id) {
      _id
    }
  }
`;

const GET_ALL_ESPECIALIDADES = gql`
  query GetAllDataWebPrivate {
    getAllDataWebPrivate {
      _id,
      categoria,
      descripcion,
      especialidad,
      imagen,
      showNavBar,
      icono
    }
  }
`;

const REGISTERUSERMKT = gql`
  mutation RegisterMkt($input: CreateUserMktInputDto!) {
    registerMkt(createUserInput: $input) {
      email
      password
      status
      username
    }
  }
`;


const GETUSERMKTBYID = gql`
  query getUserMktByID($id: String!) {
    getUserMktByID(id: $id) {
      email
      password
      status
      username
      roles
    }
  }
`;

const UPDATEUSERMKT = gql`
  mutation UpdateUserMkt($id: String!, $input: UpdateUserMktInputDto!) {
    updateUserMkt(id: $id, updateUserMktInput: $input) {
      email
      status
      username
      roles
    }
  }
`;


const UPDATEPASSWORDBYEMAIL = gql`
  mutation UpdatePasswordByEmail($email: String!, $passwordOld: String!, $passwordNew: String!) {
    updatePasswordByEmail(email: $email, passwordOld: $passwordOld, passwordNew: $passwordNew) {
      email
      status
      username
    }
  }
`;



const UPDATE_DATA_WEB = gql`
  mutation UpdateDataWeb($id: ID!, $input: CreateDataWebInputDto!) {
    updateDataWeb(id: $id, input: $input) {
      _id
      categoria
      descripcion
      especialidad
      imagen
      icono
      showNavBar
    }
  }
`;



const CATEGORIAS_WEB = gql`
  query GetAllDataWebPrivate{
    getAllDataWebPrivate {
      _id
      categoria
    }
  }
`;

const UPDATE_ADD_PROMOTION = gql`
  mutation UpdateAddPromotion($id: ID!, $promotion: PromotionInput!) {
    updateAddPromotion(
      id: $id,
      promotion: $promotion
    ) {
      _id
      categoria
      descripcion
      especialidad
      imagen
      promociones {
        __typename
        codPromocionSam
        descripcion
        disclaimer
        fechaExpiracion
        imagenPromocion
        nombre
        precio
        servicios
        statusPromocion
        tipoPromocion
      }
    }
  }
`;

const FIND_PROMOTION_BY_COD_PROMOCION_SAM = gql`
  query FindPromotionByCodPromocionSam($codPromocionSam: Int!) {
    findPromotionByCodPromocionSam(codPromocionSam: $codPromocionSam) {
      codPromocionSam,
      descripcion,
      disclaimer,
      fechaExpiracion,
      imagenPromocion,
      nombre,
      precio,
      servicios,
      statusPromocion,
      tipoPromocion,
      isFeatured,
      _id
    }
  }
`;

const UPDATE_PROMOCION_OF_DOCUMENT = gql`
  mutation UpdatePromocion(
    $id: ID!,
    $codPromocionSam: Int!,
    $promotion: PromotionInput!
  ) {
    updatePromocion(
      id: $id,
      codPromocionSam: $codPromocionSam,
      promotion: $promotion
    ) {
      _id
      especialidad
      descripcion
      categoria
      imagen
      showNavBar
      promociones {
        nombre
      }
    }
  }
`;

const CREATE_DATA_SUCURSAL_HORARIO = gql`
  mutation CreateDataHorario($createDataHorarioInput: CreateDataSucursalHorarioInputDto!) {
    createDataHorario(createDataHorarioInput: $createDataHorarioInput) {
      ciudad
      direccionSucursal
      horarioDomingo
      horarioEntreSemana
      horarioSabado
      nameEmpresa
      nameSucursal
    }
  }

`;

const GET_ALL_DATA_SUCURSAL_HORARIO = gql`
query GetAllDataHorarios {
    getAllDataHorarios {
         _id
        ciudad
        direccionSucursal
        horarioDomingo
        horarioEntreSemana
        horarioSabado
        nameEmpresa
        nameSucursal
        linkMaps
    }
}
`;

const GET_DATA_SUCURSAL_HORARIO_BY_ID = gql`
  query GetDataSucursalHorarioById($id: ID!) {
    getDataSucursalHorarioById(id: $id) {
      _id
      ciudad
      direccionSucursal
      horarioDomingo
      horarioEntreSemana
      horarioSabado
      nameEmpresa
      nameSucursal
      linkMaps
    }
  }
`;

const UPDATE_DATA_SUCURSAL_HORARIO= gql`
mutation UpdateDataHorario($id: ID!, $input: CreateDataSucursalHorarioInputDto!) {
  updateDataHorario(id: $id, input: $input) {
    _id
    ciudad
    direccionSucursal
    horarioDomingo
    horarioEntreSemana
    horarioSabado
    nameEmpresa
    nameSucursal
  }
}
`;

const REMOVE_DATA_SUCURSAL_HORARIO = gql`
mutation RemoveDataHorario($id: ID!) {
  removeDataHorario(id: $id) {
    _id
  }
}
`;


const GETALLUSERSMONGO = gql`
  query GetAllUsersMkt {
    getAllUsersMkt {
      _id
      email
      password
      status
      username
      avatar
    }
  }
`;

const GETALLHOMEHEROS = gql`
query AllHomeHeros {
    allHomeHeros {
        _id
        dateCreated
        imagenUrl
        linkWhatsapp
        nameCampana
    }
}
`;

const DELETEHOMEHERO = gql`
  mutation RemoveHomeHero($id: String!) {
    removeHomeHero(id: $id) {
      _id
    }
  }
`;

const CREATEHOMEHERO = gql`
  mutation CreateHomeHero($input: CreateHomeHeroInputDto!) {
    createHomeHero(createHomeHeroInput: $input) {
      _id
      imagenUrl
      linkWhatsapp
      nameCampana
    }
  }
`;


export {
  LOGIN_MUTATION_MKT,
  sucursalesActivas,
  getEspecialidadesNavBar,
  getServicesNavBar,
  getAllServicesNavBar,
  getAllEspecialidadesNavBar,
  getAllPromociones,
  getAllEspecialidadesMongo,
  getOneEspecialidadMongo,
  getEspecialidadesNavBarMongo,
  getAllPromocionesWeb,
  getOnePromotion,
  findPersonaByCedula,
  createPersona,
  getAdmisionByCodePersona,
  createOrdenesServicio,
  createOrden,
  SERVICIOS_POR_DESCUENTO,
  createPromocionesMongo,
  getAllPromocionesMongoFront,
  getAllPromocionesMongo,
  get_promocionMongoById,
  udpatePromocionMongoById,
  findPromocionMongoByCodSam,
  GET_ALL_DATA_WEB_PUBLIC,
  GET_ALL_PROMOCIONES_WEB,
  CREAR_ESPECIALIDAD,
  GET_DATA_BY_ID,
  UPDATE_DATA_WEB,
  CATEGORIAS_WEB,
  UPDATE_ADD_PROMOTION,
  FIND_PROMOTION_BY_COD_PROMOCION_SAM,
  GET_ALL_ESPECIALIDADES,
  UPDATE_PROMOCION_OF_DOCUMENT,
  GET_PROMOTIONS_FEATURED,
  getAllCategorias,
  getOneCategoria,
  CREATE_DATA_SUCURSAL_HORARIO,
  GET_ALL_DATA_SUCURSAL_HORARIO,
  GET_DATA_SUCURSAL_HORARIO_BY_ID,
  UPDATE_DATA_SUCURSAL_HORARIO,
  REMOVE_DATA_SUCURSAL_HORARIO,
  GETALLUSERSMONGO,
  REGISTERUSERMKT,
  GETUSERMKTBYID,
  UPDATEUSERMKT,
  UPDATEPASSWORDBYEMAIL,
  DELETEDATABYID,
  GETALLHOMEHEROS,
  DELETEHOMEHERO,
  CREATEHOMEHERO
}



